import React from 'react';
import { isExtraLarge } from 'utils/breakpoints';

import CustomOverlayComponent from './customOverlayComponent';

const InfoWindow = (props) => (
	<CustomOverlayComponent
		{...props}
		animationDelay={250}
		className="info-window"
		appendToMap={!isExtraLarge(props.viewportWidth)}
		gesturesDisabled={!isExtraLarge(props.viewportWidth)}
	/>
);

export default InfoWindow;
